import { Avatar, Divider, ListItemIcon, ListItemProps, ListItemText, styled } from '@mui/material';
import React, { ReactNode, useContext } from 'react';
import { getDisplayName, getUserInitials, UserForAppBar } from '../../../utils/userName';
import { AccountMenuItem } from '../AccountMenuItem';
import { AccountMenuContext } from './context';

const StyledAccountMenuItem = styled(AccountMenuItem)({
  minHeight: 54,
});

/**
 * User avatar and name.
 *
 * Not shown when the user is logged out.
 */
export function UserInfo({
  /**
   * Defaults to user prop passed to <AppBarLayout>
   */
  user: userProp,
  /**
   * Optional subtitle shown under the name — a role (e.g. "Trader") or the user's email
   * address. Omit entirely when the product has no role concept.
   */
  subtitle,
  ...rest
}: { user?: UserForAppBar; subtitle?: ReactNode } & ListItemProps) {
  const accountMenuContext = useContext(AccountMenuContext)!;

  // This was originally a simple component without context or a user prop, but app
  // developers were rendering it incorrectly. The context makes it more plug&play.
  const user = userProp ?? accountMenuContext.user;

  if (!user) {
    return null;
  }

  return (
    <>
      <StyledAccountMenuItem onClick={(event: React.MouseEvent<'div'>) => event.stopPropagation()} {...rest}>
        <ListItemIcon sx={{ mr: 2 }}>
          <Avatar sx={{ width: 24, height: 24, fontSize: 12 }}>{getUserInitials(user)}</Avatar>
        </ListItemIcon>
        <ListItemText
          primary={getDisplayName(user)}
          secondary={subtitle}
          slotProps={{ secondary: { variant: 'label3', color: 'textSecondary' } }}
        />
      </StyledAccountMenuItem>
      <Divider />
    </>
  );
}
